import { render, staticRenderFns } from "./EditEmailsModal.vue?vue&type=template&id=a553163c&"
import script from "./EditEmailsModal.vue?vue&type=script&lang=js&"
export * from "./EditEmailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports